import { Outlet } from "react-router-dom";
import { DashboardNavigationItemsContainer } from "@platform/layouts/DashboardNavigation";
import { AppLayout } from "./AppLayout";
import { DashboardAlertBannerContainer } from "@platform/layouts/DashboardAlertBanner";

export type Props = {
  children?: React.ReactNode;
  title: string;
};

export function DashboardLayout({ children, title }: Props) {
  return (
    <AppLayout
      isWithSidebar
      sidebar={<DashboardNavigationItemsContainer />}
      title={title}
    >
      <DashboardAlertBannerContainer />
      {children ?? <Outlet />}
    </AppLayout>
  );
}

export default DashboardLayout;
